import React, { useState, useEffect } from "react";
import Header from "./components/Header";
import ChainDropdown from "./components/chain_dropdown";
import CustomChainFlowAnalytics from "./components/CustomChainFlowAnalytics";
import BreakdownTable from "./components/BreakdownTable";
import { getAnalytics, getObjectAnalyser, getOffices } from "./Controller.js";

import "./style.css";
import DashboardLayout from "../../layout/dashboardLayout/DashboardLayout.js";
import { Space } from "antd";
import SummaryCards from "./components/SummaryCards.js";
import RetentionChart from "./components/RetentionChart.js";
import { Space50v } from "./components/Space50v.js";
import ObjectAnalysis from "./components/ObjectAnalysis.js";

const Analytics = () => {
  const [filters, setFilters] = useState({
    period: "Monthly",
    interval: "1 Month",
    chain: null,
    offices: [],
  });

  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);

  const fetchData = async () => {
    setLoading(true);
    try {
      const result = await getAnalytics({
        period: filters.period.toLowerCase(),
        interval: parseInt(filters.interval.split(" ")[0]),
        chain: filters.chain,
        offices: filters.offices,
      });
      console.log("result", result);
      setData(result);
    } catch (err) {
      console.error(err);
      setData(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!filters.chain) return;
    // if (filters.offices && filters.offices.length === 0) return;
    fetchData();
  }, [filters]);

  return (
    <DashboardLayout>
      {/* <Space size={50} direction="vertical" style={{margin: '50px 30px 30px 30px'}}> */}
      <Space50v>
        <Header
          initialTab={filters.period}
          onTabChange={(tab) => setFilters((prev) => ({ ...prev, period: tab }))}
          onIntervalChange={(interval) => setFilters((prev) => ({ ...prev, interval }))}
          onOfficeChange={(offices) => setFilters((prev) => ({ ...prev, offices }))}
        />
        {/* Summary + Retention */}
        <SummaryCards data={data} period={filters.period} /> {/*data was originally data.summaryData I changed it to just data */}
        <RetentionChart data={data} loading={loading} offices={filters.offices} />
        {/* Custom Chain Flow Analytics */}
        <Space size={30} direction="vertical">
          <ChainDropdown chain={filters.chain} setChain={(value) => setFilters((prev) => ({ ...prev, chain: value }))} />
          {data && (
            <>
              <CustomChainFlowAnalytics data={data.chain_flow_stats} offices={filters.offices} />
              <BreakdownTable data={data.chain_flow_stats} offices={filters.offices} />
            </>
          )}
        </Space>
        <ObjectAnalysis filters={filters} />
      </Space50v>
    </DashboardLayout>
  );
};

export default Analytics;
